angular.module('bmsApp.user')
	.controller('EmptyCtrl',
		[
			'$scope',
			'$log',
			'AuthService',
			'$rootScope',
			'AUTH_EVENTS',
			'$state',
			function ($scope, $log, AuthService, $rootScope, AUTH_EVENTS, $state) {

				$state.go('main.dashboard.overview');

			}
		]);
